import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFail = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: .75,
			y: .75,
			width: 62.5,
			height: 62.5,
			rx: 31.25,
			fill: "#FFF2F0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .75,
			y: .75,
			width: 62.5,
			height: 62.5,
			rx: 31.25,
			stroke: "#FFCCC7",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26 26L38 38M38 26L26 38",
			stroke: "#FF4D4F",
			strokeWidth: 2.5,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgFail);
export default ForwardRef;
